"use strict";

var _values2 = _interopRequireDefault(require("lodash/values"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var excludedFileTypes = {
  '.ai': 'application/postscript'
};
var imageUploadTypes = {
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.bmp': 'image/bmp',
  '.tiff': 'image/tiff',
  '.png': 'image/png',
  '.gif': 'image/gif'
};
var fileUploadTypes = {
  '.pdf': 'application/pdf',
  '.eps': 'application/postscript',
  '.psd': 'image/vnd.adobe.photoshop',
  '.zip': 'application/x-zip-compressed',
  '.rar': 'application/x-rar-compressed',
  '.7z': 'application/x-7z-compressed',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.csv': 'text/csv'
};
var imageIEUploadTypes = ['application/jpg', 'application/jpeg', 'application/png', 'application/bmp', 'application/gif', 'application/tiff'];
var fileIEUploadTypes = ['application/postscript', 'image/vnd.adobe.photoshop', 'application/x-zip-compressed', 'application/x-rar-compressed', 'application/x-7z-compressed'];
var maxUploadSize = 1024000000; //1024MB (1GB)

var imageTypes = (0, _values2["default"])(imageUploadTypes).concat(imageIEUploadTypes);
var fileTypes = (0, _values2["default"])(fileUploadTypes).concat(fileIEUploadTypes);
module.exports = {
  imageUploadTypes: imageUploadTypes,
  imageIEUploadTypes: imageIEUploadTypes,
  excludedFileTypes: excludedFileTypes,
  fileUploadTypes: fileUploadTypes,
  fileIEUploadTypes: fileIEUploadTypes,
  maxUploadSize: maxUploadSize,
  fileTypes: fileTypes,
  imageTypes: imageTypes
};